import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'customDecimalFormat',
  standalone: true,
})
export class CustomDecimalFormatPipe implements PipeTransform {
  transform(value: number): string {
    let data = value.toFixed(40);

    if (data == null || Number.isNaN(Number(data))) return '';

    const [intPart, decimalPart = ''] = data.split('.');
    let realDigitIndex = -1;

    // Find first non-zero decimal digit
    for (let i = 0; i < decimalPart.length; i++) {
      if (decimalPart[i] !== '0') {
        realDigitIndex = i;
        break;
      }
    }

    if (realDigitIndex === -1) {
      return intPart;
    }

    const digitsToShow = realDigitIndex + 2; // real digit + 1 extra
    const trimmed = data.substring(0, data.indexOf('.') + 1 + digitsToShow);
    return trimmed;
  }
}
